import _regeneratorRuntime from "/builds/adn/dashboard-vuejs/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _toConsumableArray from "/builds/adn/dashboard-vuejs/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "/builds/adn/dashboard-vuejs/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _typeof from "/builds/adn/dashboard-vuejs/node_modules/@babel/runtime/helpers/esm/typeof.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.dot-all.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.sticky.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
/**
 * Created by jiachenpan on 16/11/18.
 */

var dayMillisecond = 24 * 60 * 60 * 1000;

/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string}
 */
export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null;
  }
  var format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}';
  var date;
  if (_typeof(time) === 'object') {
    date = time;
  } else {
    if (typeof time === 'string' && /^[0-9]+$/.test(time)) {
      time = parseInt(time);
    }
    if (typeof time === 'number' && time.toString().length === 10) {
      time = time * 1000;
    }
    date = new Date(time);
  }
  var formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  };
  var time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, function (result, key) {
    var value = formatObj[key];
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') {
      return ['日', '一', '二', '三', '四', '五', '六'][value];
    }
    if (result.length > 0 && value < 10) {
      value = '0' + value;
    }
    return value || 0;
  });
  return time_str;
}

/**
 * @param {number} time
 * @param {string} option
 * @returns {string}
 */
export function formatTime(time, option) {
  if (('' + time).length === 10) {
    time = parseInt(time) * 1000;
  } else {
    time = +time;
  }
  var d = new Date(time);
  var now = Date.now();
  var diff = (now - d) / 1000;
  if (diff < 30) {
    return '刚刚';
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + '分钟前';
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前';
  } else if (diff < 3600 * 24 * 2) {
    return '1天前';
  }
  if (option) {
    return parseTime(time, option);
  } else {
    return d.getMonth() + 1 + '月' + d.getDate() + '日' + d.getHours() + '时' + d.getMinutes() + '分';
  }
}

/**
 * @param {string} url
 * @returns {Object}
 */
export function getQueryObject() {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
  url = url || window.location.href;
  var search = url.substring(url.lastIndexOf('?') + 1);
  var obj = {};
  var reg = /([^?&=]+)=([^?&=]*)/g;
  search.replace(reg, function (rs, $1, $2) {
    var name = decodeURIComponent($1);
    var val = decodeURIComponent($2);
    val = String(val);
    obj[name] = val;
    return rs;
  });
  return obj;
}

/**
 * @param {string} input value
 * @returns {number} output value
 */
export function byteLength(str) {
  // returns the byte length of an utf8 string
  var s = str.length;
  for (var i = str.length - 1; i >= 0; i--) {
    var code = str.charCodeAt(i);
    if (code > 0x7f && code <= 0x7ff) s++;else if (code > 0x7ff && code <= 0xffff) s += 2;
    if (code >= 0xDC00 && code <= 0xDFFF) i--;
  }
  return s;
}

/**
 * @param {Array} actual
 * @returns {Array}
 */
export function cleanArray(actual) {
  var newArray = [];
  for (var i = 0; i < actual.length; i++) {
    if (actual[i]) {
      newArray.push(actual[i]);
    }
  }
  return newArray;
}

/**
 * @param {Object} json
 * @returns {Array}
 */
export function param(json) {
  if (!json) return '';
  return cleanArray(Object.keys(json).map(function (key) {
    if (json[key] === undefined) return '';
    return encodeURIComponent(key) + '=' + encodeURIComponent(json[key]);
  })).join('&');
}

/**
 * @param {string} url
 * @returns {Object}
 */
export function param2Obj(url) {
  var search = url.split('?')[1];
  if (!search) {
    return {};
  }
  return JSON.parse('{"' + decodeURIComponent(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"').replace(/\+/g, ' ') + '"}');
}

/**
 * @param {string} val
 * @returns {string}
 */
export function html2Text(val) {
  var div = document.createElement('div');
  div.innerHTML = val;
  return div.textContent || div.innerText;
}

/**
 * @param {string} val
 * @returns {string}
 */
export function normalizeStringForFileName(val) {
  return val.toLowerCase().replace(/ /g, '_').replace(/[/\\?%*:|"<>()]/g, '');
}

/**
 * Merges two objects, giving the last one precedence
 * @param {Object} target
 * @param {(Object|Array)} source
 * @returns {Object}
 */
export function objectMerge(target, source) {
  if (_typeof(target) !== 'object') {
    target = {};
  }
  if (Array.isArray(source)) {
    return source.slice();
  }
  Object.keys(source).forEach(function (property) {
    var sourceProperty = source[property];
    if (_typeof(sourceProperty) === 'object') {
      target[property] = objectMerge(target[property], sourceProperty);
    } else {
      target[property] = sourceProperty;
    }
  });
  return target;
}

/**
 * @param {HTMLElement} element
 * @param {string} className
 */
export function toggleClass(element, className) {
  if (!element || !className) {
    return;
  }
  var classString = element.className;
  var nameIndex = classString.indexOf(className);
  if (nameIndex === -1) {
    classString += '' + className;
  } else {
    classString = classString.substr(0, nameIndex) + classString.substr(nameIndex + className.length);
  }
  element.className = classString;
}

/**
 * @param {string} type
 * @returns {Date}
 */
export function getTime(type) {
  if (type === 'start') {
    return new Date().getTime() - 3600 * 1000 * 24 * 90;
  } else {
    return new Date(new Date().toDateString());
  }
}

/**
 * @param {string} objectId
 * @returns {Date}
 */
export function getDateFromObjectId(objectId) {
  return new Date(parseInt(objectId.substring(0, 8), 16) * 1000);
}

/**
 * @param {Date} date
 * @returns {Date}
 */
export function getTimeStringByYYYYMMDDHHMMSS(date) {
  if (!date) {
    return undefined;
  }
  var yyyy = date.getFullYear().toString();
  var MM = pad10(date.getMonth() + 1);
  var dd = pad10(date.getDate());
  var hh = pad10(date.getHours());
  var mm = pad10(date.getMinutes());
  var ss = pad10(date.getSeconds());
  return yyyy + MM + dd + hh + mm + ss;
}

/**
 * @param {string} objectId
 * @returns {string}
 */
export function getTimeStringByYYYYMMDDHHMMSSFromObjectId(objectId) {
  if (objectId && objectId.length >= 8) {
    return getTimeStringByYYYYMMDDHHMMSS(getDateFromObjectId(objectId));
  }
}

/**
 * @param {string} objectId
 * @returns {string}
 */
export function getIDReadable(objectId) {
  /*
  const timestamp = getTimeStringByYYYYMMDDHHMMSSFromObjectId(objectId)
  if (timestamp) {
    return `${timestamp}(${objectId})`
  }
  */

  return objectId;
}

/**
 * @param {Function} func
 * @param {number} wait
 * @param {boolean} immediate
 * @return {*}
 */
export function debounce(func, wait, immediate) {
  var timeout, args, context, timestamp, result;
  var _later = function later() {
    // 据上一次触发时间间隔
    var last = +new Date() - timestamp;

    // 上次被包装函数被调用时间间隔 last 小于设定时间间隔 wait
    if (last < wait && last > 0) {
      timeout = setTimeout(_later, wait - last);
    } else {
      timeout = null;
      // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
      if (!immediate) {
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      }
    }
  };
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    context = this;
    timestamp = +new Date();
    var callNow = immediate && !timeout;
    // 如果延时不存在，重新设定延时
    if (!timeout) timeout = setTimeout(_later, wait);
    if (callNow) {
      result = func.apply(context, args);
      context = args = null;
    }
    return result;
  };
}
export function asyncDebounce(func, wait, immediate) {
  var debounced = debounce(/*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(resolve, reject, bindSelf, args) {
      var result;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return func.bind(bindSelf).apply(void 0, _toConsumableArray(args));
          case 3:
            result = _context.sent;
            resolve(result);
            _context.next = 10;
            break;
          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](0);
            reject(_context.t0);
          case 10:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 7]]);
    }));
    return function (_x, _x2, _x3, _x4) {
      return _ref.apply(this, arguments);
    };
  }(), wait, immediate);

  // This is the function that will be bound by the caller, so it must contain the `function` keyword.
  function returnFunc() {
    var _this = this;
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    return new Promise(function (resolve, reject) {
      debounced(resolve, reject, _this, args);
    });
  }
  return returnFunc;
}

/**
 * This is just a simple version of deep copy
 * Has a lot of edge cases bug
 * If you want to use a perfect deep copy, use lodash's _.cloneDeep
 * @param {Object} source
 * @returns {Object}
 */
export function deepClone(source) {
  if (!source && _typeof(source) !== 'object') {
    throw new Error('error arguments', 'deepClone');
  }
  var targetObj = source.constructor === Array ? [] : {};
  Object.keys(source).forEach(function (keys) {
    if (source[keys] && _typeof(source[keys]) === 'object') {
      targetObj[keys] = deepClone(source[keys]);
    } else {
      targetObj[keys] = source[keys];
    }
  });
  return targetObj;
}

/**
 * @param {Array} arr
 * @returns {Array}
 */
export function uniqueArr(arr) {
  return Array.from(new Set(arr));
}

/**
 * @returns {string}
 */
export function createUniqueString() {
  var timestamp = +new Date() + '';
  var randomNum = parseInt((1 + Math.random()) * 65536) + '';
  return (+(randomNum + timestamp)).toString(32);
}

/**
 * Check if an element has a class
 * @param {HTMLElement} elm
 * @param {string} cls
 * @returns {boolean}
 */
export function hasClass(ele, cls) {
  return !!ele.className.match(new RegExp('(\\s|^)' + cls + '(\\s|$)'));
}

/**
 * Add class to element
 * @param {HTMLElement} elm
 * @param {string} cls
 */
export function addClass(ele, cls) {
  if (!hasClass(ele, cls)) ele.className += ' ' + cls;
}

/**
 * Remove class from element
 * @param {HTMLElement} elm
 * @param {string} cls
 */
export function removeClass(ele, cls) {
  if (hasClass(ele, cls)) {
    var reg = new RegExp('(\\s|^)' + cls + '(\\s|$)');
    ele.className = ele.className.replace(reg, ' ');
  }
}

/**
 * Check if the given element is off-screen
 * @param {HTMLElement} el
 * @param {boolean} useXYOnly
 * @returns {boolean}
 */
export function isOffScreen(el, useXYOnly) {
  var rect = el.getBoundingClientRect();
  if (useXYOnly) {
    return rect.x < 0 || rect.y < 0 || rect.x > window.innerWidth || rect.y > window.innerHeight;
  }
  return rect.x + rect.width < 0 || rect.y + rect.height < 0 || rect.x > window.innerWidth || rect.y > window.innerHeight;
}

/**
 * Make the number pad10 (00, 01, ..., 09, 10, 11, ..., 99, 100, ...)
 * @param {Number} number
 * @returns {String}
 */
export function pad10(number) {
  return number < 10 ? '0' + number : number;
}

/**
* Make the number pad by length (ex: length=2 -> 00, 01, ..., 09, 10, 11, ..., 99, 100, ...)
* @param {Number} number
* @param {Number} length
* @returns {String}
*/
export function pad(number, length) {
  var str = '' + number;
  while (str.length < length) {
    str = '0' + str;
  }
  return str;
}

/**
 * Get the RFC3339 formatted string from a Date object(UTC).
 * @param {Date} date
 * @returns {String}
 */
export function toRFC3339String(date) {
  return date.getUTCFullYear() + '-' + pad10(date.getUTCMonth() + 1) + '-' + pad10(date.getUTCDate()) + 'T' + pad10(date.getUTCHours()) + ':' + pad10(date.getUTCMinutes()) + ':' + pad10(date.getUTCSeconds()) + 'Z';
}

/**
 * Get the RFC3339 formatted string from a Date object(by local timezone).
 * @param {Date} date
 * @returns {String}
 */
export function toRFC3339StringByLocalTimezone(date) {
  if (!date) {
    return '';
  }
  if (!(typeof date.getMonth === 'function')) {
    date = new Date(date);
  }
  return date.getFullYear() + '-' + pad10(date.getMonth() + 1) + '-' + pad10(date.getDate()) + 'T' + pad10(date.getHours()) + ':' + pad10(date.getMinutes()) + ':' + pad10(date.getSeconds()) + getTimezoneOffsetString(date.getTimezoneOffset());
}

/**
 * Get the timezone suffix string from the offset.
 * @param {Number} offset
 * @returns {String}
 */
export function getTimezoneOffsetString(offset) {
  if (offset === 0) {
    return 'Z';
  }
  var sign = offset > 0 ? '-' : '+';
  offset = Math.abs(offset);
  return sign + pad10(Math.floor(offset / 60)) + ':' + pad10(offset % 60);
}

/**
 * Get the start timestamp of the given Date by the unit of the segment.
 * @param {Date} date
 * @param {Number} interval
 * @returns {Date}
 */
export function getStartTimestampByDateAndSegmentInterval(date, interval) {
  var timestamp = date.getTime();
  var nextTime = new Date(timestamp - timestamp % interval);
  return nextTime;
}

/**
 * Get the start timestamp of the given Date by hour interval unit.
 * @param {Date} date
 * @returns {Date}
 */
export function getStartTimestampByDateAndHourInterval(date) {
  return getStartTimestampByDateAndSegmentInterval(date, 1000 * 60 * 60);
}

/**
 * Get the start timestamp of the given Date by day interval unit.
 * @param {Date} date
 * @returns {Date}
 */
export function getStartTimestampByDateAndDayInterval(date) {
  var nextTime = new Date(date.getTime());
  var hOffset = 8;
  var hEndTime = 24 - hOffset;
  if (date.getUTCHours() < hEndTime) {
    nextTime = new Date(date.getTime() - dayMillisecond);
  }
  nextTime.setUTCHours(hEndTime);
  nextTime.setUTCMinutes(0);
  nextTime.setUTCSeconds(0);
  nextTime.setUTCMilliseconds(0);

  // let nextTime = getStartTimestampByDateAndSegmentInterval(date, 1000*60*60*24)
  // nextTime = new Date(nextTime.getTime()-1000*60*60*8)

  return nextTime;
}

/**
 * Get the last day of the previous month based on the given Date.
 * @param {Date} originalDate (Optional) If not given then using current Date
 * @returns {Date}
 */
export function getLastDayPreviousMonth() {
  var originalDate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
  var result = new Date(originalDate);
  result.setDate(0); // set to last day of previous month
  return result;
}

/**
 * Get the last day of the given month based on the given Date.
 * @param {Date} originalDate (Optional) If not given then using current Date
 * @returns {Date}
 */
export function getLastDayGivenMonth() {
  var originalDate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
  var today = new Date(originalDate);
  var result = new Date(today.getFullYear(), today.getMonth() + 1, 0);
  return result;
}

/**
 * Get the previous day of the given day based on the given Date.
 * @param {Date} originalDate (Optional) If not given then using current Date
 * @returns {Date}
 */
export function getPreviousDayGivenDay() {
  var originalDate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
  var today = new Date(originalDate);
  var result = new Date(today.getTime() - dayMillisecond);
  return result;
}

/**
 * Get the week day of the given day based on the given Date.
 * @param {Number} weekday 0: Sunday 1: Monday ... 6: Saturday
 * @param {Date} originalDate (Optional) If not given then using current Date
 * @returns {Date}
 */
export function getWeekDayGivenDay() {
  var weekday = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var originalDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Date();
  var today = new Date(originalDate);
  var currentDay = today.getDay();
  var distance = weekday - currentDay;
  var result = new Date(today.getTime() + distance * dayMillisecond);
  return result;
}

/**
 * Get the first day of the previous month based on the given Date.
 * @param {Date} originalDate (Optional) If not given then using current Date
 * @returns {Date}
 */
export function getFirstDayPreviousMonth() {
  var originalDate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
  return getFirstDayGivenMonth(getLastDayPreviousMonth(originalDate));
}

/**
 * Get the first day of the month based on the given Date.
 * @param {Date} originalDate (Optional) If not given then using current Date
 * @returns {Date}
 */
export function getFirstDayGivenMonth() {
  var originalDate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
  var result = new Date(originalDate);
  result.setDate(1); // set to the first day of that month
  return result;
}

/**
 * Get the begin time of the day based on the given Date.
 * @param {Date} originalDate (Optional) If not given then using current Date
 * @returns {Date}
 */
export function getBeginTimeGivenDay() {
  var originalDate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
  var result = new Date(originalDate);
  result.setHours(0);
  result.setMinutes(0);
  result.setSeconds(0);
  result.setMilliseconds(0);
  return result;
}

/**
 * Get the end time of the day based on the given Date.
 * @param {Date} originalDate (Optional) If not given then using current Date
 * @returns {Date}
 */
export function getEndTimeGivenDay() {
  var originalDate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
  var result = new Date(originalDate);
  result.setHours(23);
  result.setMinutes(59);
  result.setSeconds(59);
  result.setMilliseconds(999);
  return result;
}

/**
 * Detect is the browser in mobile or desktop
 * @returns {Boolean}
 */
export function isMobileDevice() {
  return window.navigator.userAgent.toLowerCase().includes('mobi');
}
export { dayMillisecond };